const danhSachThongBao = (state) => state.danhSachThongBao;

export default {
  danhSachThongBao,
};
